/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyPasscode} from '../api'

export const useMutationVerifyPasscode = createReactQueryMutationHook('verifyPasscode', verifyPasscode)
